import {
  FiHome,
  FiBook,
  FiUsers,
  FiUserCheck,
  FiFileText,
  FiFolder,
  FiBarChart2,
  FiDollarSign,
  FiSettings,
  FiDatabase,
  FiEdit3,
  FiShield,
  FiCheckSquare,
  FiCalendar,
  FiCreditCard,
  FiClock,
  FiClipboard,
  FiAward
} from 'react-icons/fi';

// Menu IDs should match institute_submenu.id from your database
// requiredTypes: array of institute types that can see this menu item
// If not specified, menu is visible to all types
export const menuItems = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    icon: FiHome,
    path: '/dashboard',
    menuId: 1, // institute_submenu.id for dashboard overview
    requiredTypes: ['online', 'offline', 'library', 'both'] // All types
  },
  {
    id: 'masters',
    title: 'Master',
    icon: FiDatabase,
    requiredTypes: ['online', 'offline', 'both'], // Not for library
    submenu: [
      { title: 'Categories', path: '/masters/tradegroups', menuId: 10 },
      { title: 'Sub Categories', path: '/masters/trades', menuId: 11 },
      { title: 'Subjects', path: '/masters/subjects', menuId: 12 },
      { title: 'Chapters', path: '/masters/chapters', menuId: 13 },
      { title: 'Topic', path: '/masters/topics', menuId: 14 },
      { title: 'Classes', path: '/masters/classes', menuId: 44, requiredTypes: ['offline', 'both'] },
      { title: 'Batches', path: '/masters/batches', menuId: 45, requiredTypes: ['offline', 'both'] }
    ]
  },
  {
    id: 'fee-collection',
    title: 'Fee Collection',
    icon: FiDollarSign,
    requiredTypes: ['offline', 'both'], // Mainly for offline institutes
    submenu: [
      { title: 'Fee Master', path: '/fee-collection/master', menuId: 31 },
      { title: 'Fee Group', path: '/fee-collection/group', menuId: 32 },
      { title: 'Fee Type', path: '/fee-collection/type', menuId: 33 },
      { title: 'Fee Discount', path: '/fee-collection/discount', menuId: 34 },
      { title: 'Fee Reminders', path: '/fee-collection/reminders', menuId: 54 }
    ]
  },
  {
    id: 'courses',
    title: 'Courses',
    icon: FiBook,
    requiredTypes: ['online', 'both'], // Online courses
    submenu: [
      { title: 'Course Categories', path: '/courses/categories', menuId: 3 },
      { title: 'Courses', path: '/courses/list', menuId: 2 },
      { title: 'Allow Courses', path: '/courses/allow', menuId: 4 },
      { title: 'Live Video List', path: '/courses/live-videos', menuId: 5 }
    ]
  },
  {
    id: 'HRMS',
    title: 'HRMS',
    icon: FiUsers,
    requiredTypes: ['online', 'offline', 'library', 'both'], // All types need staff
    submenu: [
      { title: 'All Staff', path: '/teachers', menuId: 6 },
      { title: 'Add Staff', path: '/teachers/create', menuId: 7 },
      { title: 'Generate Staff ID Cards', path: '/staff/id-cards', menuId: 51, requiredTypes: ['offline', 'both'] },
      { title: 'Staff Attendance', path: '/hrms/attendance', menuId: 35 },
      { title: 'Payroll', path: '/hrms/payroll', menuId: 36 },
      { title: 'Leave Request', path: '/hrms/leave-request', menuId: 37 },
    ]
  },
  {
    id: 'students',
    title: 'Students',
    icon: FiUserCheck,
    requiredTypes: ['online', 'offline', 'both'], // Not for library (they have members)
    submenu: [
      { title: 'All Students', path: '/students', menuId: 9 },
      { title: 'Generate ID Cards', path: '/students/id-cards', menuId: 48, requiredTypes: ['offline', 'both'] },
      { title: 'Enrollments', path: '/students/enrollments', menuId: 27 },
      { title: 'Progress', path: '/students/progress', menuId: 28 }
    ]
  },
  {
    id: 'attendance',
    title: 'Attendance',
    icon: FiCheckSquare,
    requiredTypes: ['offline', 'both'], // Only for offline institutes
    submenu: [
      { title: 'Student QR Scanner', path: '/attendance/scanner', menuId: 49 },
      { title: 'Mark Attendance', path: '/attendance/mark', menuId: 46 },
      { title: 'Attendance Reports', path: '/attendance/reports', menuId: 47 }
    ]
  },
  {
    id: 'staff-attendance',
    title: 'Staff Attendance',
    icon: FiUsers,
    requiredTypes: ['offline', 'both'],
    submenu: [
      { title: 'Staff QR Scanner', path: '/staff/attendance/scanner', menuId: 52 },
      { title: 'Staff Reports', path: '/staff/attendance/reports', menuId: 53 }
    ]
  },
  {
    id: 'holidays',
    title: 'Holidays',
    icon: FiCalendar,
    path: '/holidays',
    menuId: 50,
    requiredTypes: ['offline', 'both']
  },
  {
    id: 'timetable',
    title: 'Timetable',
    icon: FiClock,
    path: '/timetable',
    menuId: 55,
    requiredTypes: ['offline', 'both']
  },
  {
    id: 'assignments',
    title: 'Assignments',
    icon: FiClipboard,
    requiredTypes: ['offline', 'both'],
    submenu: [
      { title: 'All Assignments', path: '/assignments', menuId: 56 },
      { title: 'Create Assignment', path: '/assignments/create', menuId: 57 }
    ]
  },
  {
    id: 'report-cards',
    title: 'Report Cards',
    icon: FiAward,
    requiredTypes: ['offline', 'both'],
    submenu: [
      { title: 'Offline Exams', path: '/report-cards/exams', menuId: 59 },
      { title: 'View Report Cards', path: '/report-cards/view', menuId: 62 }
    ]
  },
  {
    id: 'exams',
    title: 'Test Series',
    icon: FiFileText,
    requiredTypes: ['online', 'offline', 'both'], // Not for library
    submenu: [
      { title: 'All Exams', path: '/exams', menuId: 12 },
      { title: 'Question Bank', path: '/questions', menuId: 13 }
    ]
  },
  {
    id: 'blogs',
    title: 'Blog Articles',
    icon: FiEdit3,
    path: '/blogs',
    menuId: 15,
    requiredTypes: ['online', 'offline', 'both'] // Not for library
  },
  {
    id: 'legal-pages',
    title: 'Legal Pages',
    icon: FiShield,
    path: '/legal-pages',
    menuId: 16,
    requiredTypes: ['online', 'offline', 'both'] // Not for library
  },
  {
    id: 'content',
    title: 'Content Library',
    icon: FiFolder,
    requiredTypes: ['online', 'both'], // Digital content for online
    submenu: [
      { title: 'Documents', path: '/content/documents', menuId: 17 },
      { title: 'Videos', path: '/content/videos', menuId: 18 },
      { title: 'Upload', path: '/content/upload', menuId: 19 }
    ]
  },
  {
    id: 'reports',
    title: 'Reports',
    icon: FiBarChart2,
    requiredTypes: ['online', 'offline', 'library', 'both'], // All types
    submenu: [
      { title: 'Revenue', path: '/reports/revenue', menuId: 20 },
      { title: 'Course Performance', path: '/reports/courses', menuId: 21 },
      { title: 'Student Analytics', path: '/reports/students', menuId: 22 }
    ]
  },
  {
    id: 'payments',
    title: 'Payments',
    icon: FiDollarSign,
    requiredTypes: ['online', 'both'], // Online payments
    submenu: [
      // { title: 'Transactions', path: '/payments/transactions', menuId: 23 },
      // { title: 'History', path: '/payments/history', menuId: 24 },
      { title: 'Failed Payments', path: '/payments/failed', menuId: 30 }
    ]
  },
  {
    id: 'settings',
    title: 'Settings',
    icon: FiSettings,
    requiredTypes: ['online', 'offline', 'library', 'both'], // All types
    submenu: [
      { title: 'Profile & General', path: '/settings', menuId: 25 },
      { title: 'Branding & Banners', path: '/settings/branding', menuId: 26 },
      { title: 'Role Permissions', path: '/settings/permissions', menuId: 29 }
    ]
  }
];

// Build path to menuId map for permission checking
export const pathToMenuId = {};

menuItems.forEach(item => {
  if (item.path && item.menuId) {
    pathToMenuId[item.path] = item.menuId;
  }
  if (item.submenu) {
    item.submenu.forEach(sub => {
      if (sub.path && sub.menuId) {
        pathToMenuId[sub.path] = sub.menuId;
      }
    });
  }
});

// Helper to get menuId from path (handles dynamic routes)
export const getMenuIdFromPath = (pathname) => {
  // Exact match first
  if (pathToMenuId[pathname]) {
    return pathToMenuId[pathname];
  }
  
  // Dynamic route patterns
  if (pathname.startsWith('/courses/')) {
    if (pathname.includes('/edit') || pathname.includes('/addcontent') || pathname.includes('/viewcontent') || pathname.includes('/import')) {
      return 2; // Courses menuId
    }
  }
  if (pathname.startsWith('/teachers/') && pathname.includes('/edit')) {
    return 6; // Teachers menuId
  }
  if (pathname.startsWith('/questions/')) {
    return 13; // Question Bank menuId
  }
  if (pathname.startsWith('/exams/') && pathname.includes('/questions')) {
    return 12; // Exams menuId
  }
  if (pathname.startsWith('/blogs/')) {
    return 15; // Blogs menuId
  }
  if (pathname.startsWith('/legal-pages/')) {
    return 16; // Legal Pages menuId
  }
  if (pathname.startsWith('/assignments/') && pathname.includes('/submissions')) {
    return 56; // Assignments menuId
  }
  if (pathname.startsWith('/assignments/') && pathname.includes('/edit')) {
    return 57; // Create/Edit Assignment menuId
  }
  if (pathname.startsWith('/report-cards/')) {
    return 59; // Report Cards menuId
  }
  
  // Default: allow (for routes without specific menuId)
  return null;
};
